import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations } from 'drizzle-orm';
import {
  boolean,
  integer,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';
import { softDelete } from '../columns/soft-delete';
import { artists } from './artists';

export const songOriginalKeyEnum = pgEnum('song_original_key', [
  'C',
  'C#',
  'D',
  'Eb',
  'E',
  'F',
  'F#',
  'G',
  'G#',
  'A',
  'Bb',
  'B',
  'Cm',
  'C#m',
  'Dm',
  'Ebm',
  'Em',
  'Fm',
  'F#m',
  'Gm',
  'G#m',
  'Am',
  'Bbm',
  'Bm',
]);

export const songs = pgTable('songs', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  title: text('title').notNull(),
  originalKey: songOriginalKeyEnum('original_key').notNull(),
  capo: integer('capo'),
  notes: text('notes'),
  content: text('content').notNull(),
  artistId: uuid('artist_id').references(() => artists.id),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
  ...softDelete,
});

export const songsRelations = relations(songs, ({ one }) => ({
  artist: one(artists, {
    fields: [songs.artistId],
    references: [artists.id],
  }),
}));

export type Song = InferSelectModel<typeof songs>;
export type CreateSongInput = InferInsertModel<typeof songs>;
export type UpdateSongInput = Partial<CreateSongInput>;
